import { pattern } from './pattern';
export const phoneValidator = (value = '') => {
    const phoneNumberRegex = new RegExp(pattern.phoneNumber);
    let _temp = value
        .replace(/\s/g, '')
        .replace(/-/g, '')
        .replace(/\+/g, '')
        .replace(/\(/g, '')
        .replace(/\)/g, '')
    if (phoneNumberRegex.test(_temp)) return true;
    else return false;
}